module.exports = __webpack_public_path__ + "img/s1-0.5c19370f.jpg";